import React from 'react';
import { Modal } from 'ui-kit';
import './OwnerRezIntroModal.scss';
import LogoLinks, { Integrations } from 'components/Dashboard/Share/LogoLinks';

interface IOwnerRezIntroModalProps {
  isOpen: boolean;
  onCancel: () => void;
}

export default function OwnerRezIntroModal({ isOpen, onCancel }: IOwnerRezIntroModalProps) {
  return (
    <Modal
      visible={isOpen}
      onCancel={onCancel}
      title={'Your stores are ready!'}
      className="OwnerRezIntroModal"
      width={650}
      footer={null}
    >
      <p>Next steps:</p>
      <ol className="action-list">
        <li>Modify stores to reflect your prices and add any products.</li>
        <li>
          The link for each store has been added to the OwnerRez Custom Field HOSTCO per property.
          Use code PXHOSTCO in your outgoing messages to auto-populate the Host Co link for any
          listing!
        </li>
        <li>
          Want examples of what to say? Click &quot;share&quot; in the upper right hand corner of
          your store to see our messaging templates and your store links.
        </li>
      </ol>

      <LogoLinks highlightIntegration={Integrations.ownerrez} />
    </Modal>
  );
}
